export const educationData = [
    {
        id: 1,
        institution: 'Vandana International School',
        course: 'Higher Secondary Education',
        startYear: '2008',
        endYear: '2022'
    },
    {
        id: 2,
        institution: 'Guru Tegh Bahadur Institute Of Technology',
        course: 'Bachelor of Technology',
        startYear: '2022',
        endYear: '2026'
    },
   
]